<template>
  <div>
  <section class="">
        <div class="container">
            <figure><img src="/static/images/index/i80banner.png" class="img-responsive"></figure>
        </div>
    </section>
    <section>
        <div class="container">
            <ol class="breadcrumb hidden-xs">
                <li><a href="/">首頁</a></li>
                <li><a href="#">聯盟經營者</a></li>
                <li class="active">內文</li>
            </ol>
            <div class="row">
                <div class="col-sm-2">
                    <div class="aside_menu">
                        <h4 class="title">關於我們</h4>
                        <ul class="list-unstyled">
                            <li class="active item"><a href="">聯盟推廣者</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-sm-10">
                    <article>
                        <h4 class="title">為甚麼要推廣i80?</h4>
                        <div class="editor">
                        由於我們處於百物齊漲，唯獨薪水不增的時代，我們工作都是為了要賺錢養家，但是有沒有更好的方法邦你降低支出呢?
                        目前有許多的通路都是剝削消費者居多並未考量消費者所需而設立，而我們愛幫您就是希望能提供第三方的公正平台來邦助消費者，
                        邦助商品的把關與降低消費者的支出。<br/>那為甚麼消費者要推廣愛幫您呢?
                        推廣i80的福利，首先自己加入i80就享有個人回饋，所以只要在i80平台消費是比外面還便宜的，
                        此外透過您推薦的朋友加入後，往後任何消費我們都將再額外回饋廣告行銷費用給您而且這都是永久不變的。
                        另外我們不時舉辦各種會員的活動與聚會，讓我們i80的會員們能像一個大家庭一樣，一起消費一起買到便宜又好的商品。
                        </div>
                        <hr/>
                        <div class="editor">
                        如果您覺得這個平台實在太好了，請先加入成為我們的會員，並介紹你的朋友讓他也加入成為會員，
                        加入後您便是i80消費者聯盟的一份子。成為會員後，在聯盟的店家或是網路商品購買產品即有回饋點數。
                        </div>
                    </article>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Operators',
  data () {
    return {
      rowData: {}
    }
  },
  mounted: function () {
  }
}
</script>



// WEBPACK FOOTER //
// Operators.vue?8694b584